import { useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute, Link, type LinkProps } from '@tanstack/react-router'

import { Heading } from '@/components/ui/heading'
import { PageCard, PageLayout } from '@/components/ui/page'

import { accountMasterList } from '@/features/account/api'
import { authzTeamList } from '@/features/authz/api'
import { outletMasterList } from '@/features/outlet/api'

export const Route = createFileRoute('/_app/settings/')({
	component: Component,
})

function Component() {
	const [team, outlet, account] = useSuspenseQueries({
		queries: [
			authzTeamList.qry(),
			outletMasterList.qry(),
			accountMasterList.qry(),
		],
	})

	return (
		<PageLayout.Root>
			<PageLayout.Header breadcrumbs={[['/settings', 'Pengaturan']]} />
			<PageLayout.ContentSingleColumn>
				<PageCard.Root>
					<PageCard.Header title="Informasi Aplikasi" />
					<div className="grid grid-cols-3 gap-2 px-2 py-4">
						<CardStat
							title="Outlet"
							value={outlet.data.total}
							to="/settings/outlet"
						/>
						<CardStat
							title="Team"
							value={team.data.total}
							to="/settings/team"
						/>
						<CardStat
							title="Akun"
							value={account.data.total}
							to="/settings/user"
						/>
					</div>
				</PageCard.Root>
			</PageLayout.ContentSingleColumn>
		</PageLayout.Root>
	)
}

interface CardStatProps {
	title: string
	value: number
	to: LinkProps['to']
}

function CardStat({ title, value, to }: CardStatProps) {
	return (
		<div className="rounded-md bg-ui-bg-field-component-hover p-3 px-4 shadow-elevation-card-rest">
			<Link to={to}>
				<Heading
					level="h3"
					className="font-semibold capitalize text-ui-fg-subtle underline underline-offset-1"
				>
					{title}
				</Heading>
			</Link>
			<p className="text-right text-4xl font-semibold">{value}</p>
		</div>
	)
}
